/**
 * 判断对象是否是一个promise，即是否可以用.then
 */
export function isPromise(obj) {
    return (!!obj &&
        (typeof obj === 'object' || typeof obj === 'function') &&
        // @ts-ignore ignore
        typeof obj.then === 'function');
}
